import { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@schibsted-svp/react-ui';

import { ComponentBody } from '../../PageForm/ComponentsList/Component/ComponentBody/ComponentBody';

import type { ComponentResponse } from '../../../types';

import styles from './Component.module.scss';

type Props = {
  component: ComponentResponse;
  onClick: (component: ComponentResponse) => Promise<void>;
  isDisabled?: boolean;
};

function Component({ component, onClick, isDisabled = false }: Props) {
  const [isAdding, setIsAdding] = useState(false);

  async function onComponentClick() {
    setIsAdding(true);
    await onClick(component);
    setIsAdding(false);
  }

  return (
    <div
      className={classNames(styles.component, {
        [styles.isDisabled]: isDisabled,
      })}
      onClick={!isDisabled ? onComponentClick : undefined}
    >
      <ComponentBody
        component={component}
        index={0}
        onAddClick={() => undefined}
        onEditClick={() => undefined}
        onRemoveClick={() => undefined}
        isEditable={false}
      />
      <Button
        type="button"
        variant="standard"
        size="small"
        className={styles.addButton}
        loading={isAdding}
        iconOnly
      >
        +
      </Button>
    </div>
  );
}

export { Component };
